<header>
  <div class="container">
    <br />
    <div class="row">
      <div class="col-md-10">
      </div>
      <div class="col-md-2">
        <span style="padding-top: 3%; font-size: 1.6em; font-weight: 700; ">
          <a [routerLink]="['/home-espanol']" style="text-decoration: none; color: inherit; ">
            <div class="container" style="border: 1px solid #257dff; border-radius: 25px; ">
              &nbsp;&nbsp;Español
            </div>
          </a>
        </span>
      </div>
    </div>
  </div>
  <div class="container">
    <br />
    <div class="row">
      <div class="col-md-12">
        <span style="padding-top: 3%; font-size: 1.6em; font-weight: 700">
          GoogleAssistantPrivacyLitigation.com
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(877) 411-4704
        </span>
      </div>
    </div>
  </div>
  <br />
  <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light  border-bottom " style="background-color: #257dff ">
    <div class="container">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse justify-content-center" [ngClass]="{ show: isExpanded }">
        <ul class="navbar-nav flex-grow">
          <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link  hover_lightBlue" [routerLink]="['/home']" style="color: white; font-weight: bold ">Home</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/faq']" style="color: white; font-weight: bold">FAQs</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/notice']" style="color: white; font-weight: bold ">Notice</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/login']" style="color:white; font-weight: bold ">File Your Claim</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/claim-form']" style="color:white; font-weight: bold ">Claim Form</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/court-documents']" style="color:white; font-weight: bold ">Court Documents</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/exclusion-request']" style="color:white; font-weight: bold ">File an Exclusion</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/contact']" style="color:white; font-weight: bold ">Contact Us</a>
          </li>
        </ul>
      </div>
    </div>

  </nav>


</header>
<div class="container" style="border:1px solid #bebaba">
  <br />
  <div class="text-center" style="font-weight:bold">

    <div class="text-center" style="margin-bottom: 1em;">
      <p style="font-weight:bold; font-size:1.3em; color:red; margin-bottom: 0.25em;">Claim Filing Deadline Has Passed</p>
      <p>The deadline to submit a Claim Form was August 27, 2026.</p>
    </div>
  </div>
</div>

<div class="container">
  <div class="containerLogin login-container">
    <!--<form [formGroup]="loginInformation" (ngSubmit)="onSubmit()">
      <div class="row mt-5">
        <div class="col-md-3"></div>
        <div class="col-md-6 login-form-1">
          <div class="text-center" style="margin-bottom: 1em;">
            <p style="font-weight:bold; font-size:1.3em; color:red; margin-bottom: 0.25em;">Claim Filing Deadline Has Passed</p>
            <p>The deadline to submit a Claim Form was August 27, 2026. Claims submitted after this date may still be received, but acceptance of late claims is subject to the discretion of Class Counsel.</p>
          </div>
          <h3 class="misc-titles text-center">Login</h3>
          <div class="container" style="border:1px solid #bebaba">
            <p class="misc-titles text-center">
              <br />To submit an online claim please enter the Unique ID and PIN provided to you on your Notice.
            </p>
            <div class="form-group">
              <label for="uniqueId" style="font-weight:bold">Unique Id: <span style="color:red" class="required"> *</span></label>
              <input type="text" class="form-control" formControlName="uniqueId" trim="blur" autocomplete="off"
                     [ngClass]="{ 'is-invalid': submitted && f.uniqueId.errors }" />
              <div *ngIf="submitted && f.uniqueId.errors" class="invalid-feedback">
                <div *ngIf="f.uniqueId.errors.required">This field is required</div>
                <div *ngIf="f.uniqueId.errors.minlength">This field must be at least 8 characters</div>
                <div *ngIf="f.uniqueId.errors.maxlength">
                  This field must not be greater than 8 characters
                </div>
                <div *ngIf="f.uniqueId.errors.pattern">This field accepts only numerical digits 0-9 and characters A-Z</div>
              </div>
            </div>
            <div class="form-group">
              <label for="pin" style="font-weight:bold">Pin: <span style="color:red" class="required"> *</span></label>
              <input type="text" class="form-control" formControlName="pin" trim="blur" autocomplete="off"
                     [ngClass]="{ 'is-invalid': submitted && f.pin.errors }" />
              <div *ngIf="submitted && f.pin.errors" class="invalid-feedback">
                <div *ngIf="f.pin.errors.required">This field is required</div>
                <div *ngIf="f.pin.errors.minlength">This field must be at least 6 characters</div>
                <div *ngIf="f.pin.errors.maxlength">
                  This field must not be greater than 6 characters
                </div>
                <div *ngIf="f.pin.errors.pattern">This field accepts only numerical digits 0-9 and characters A-Z</div>
              </div>
            </div>

            <br />
            <div class="row">
              <div class="col-md-12 text-center">
                <div class="form-group">
                  <button class="btn btn-primary" id="login" [disabled]="clicked">Login</button>
                </div>
              </div>
            </div>
            <br />
            <p class="misc-titles text-center">
              If you did not receive a Notice or cannot locate your Unique ID and PIN, please click the button below
            </p>
            <div class="row">
              <div class="col-md-12 text-center">
                <a href="/file" class="btn btn-primary">Don't have a Unique Id and PIN? Click Here.</a>
              </div>
            </div>
            <br />
          </div>
          <br />
        </div>

        <div class="col-md-3"></div>
      </div>

    </form>-->
    <ngx-spinner bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"
                 type="ball-scale-multiple">
      <p style="font-size: 20px; color: white">Loading...</p>
    </ngx-spinner>
    <div class="row mt-3" *ngIf="showDivHasFiled == true">
      <div class="col-md-12 text-center" style="font-weight:bold; color:red; font-size:1.3em">
        This UniqueID has already been used, please send an email to <a href="mailto:info@googleassistantprivacylitigation.com">info@googleassistantprivacylitigation.com</a> if you need help.
      </div>
    </div>
    <div class="row mt-3" *ngIf="showDivLoginError == true">
      <div class="col-md-12 text-center" style="font-weight:bold; color:red; font-size:1.3em">
        This Unique Id and Pin incorrect, please send an email to <a href="mailto:info@googleassistantprivacylitigation.com">info@googleassistantprivacylitigation.com</a> if you need help.
      </div>
    </div>
  </div>
</div>
